import { FaWhatsapp, FaLinkedin, FaCopy } from "react-icons/fa";
import { generateShareMessage } from "./Message";
import { useToastHelpers } from "../Toasts/ToastUtils";
const BASE_URL = process.env.REACT_APP_UI_BASE_URL;

export default function ShareJobButtons({ job }) {
  const { successToast, errorToast } = useToastHelpers();
  const message = generateShareMessage(job);
  const jobUrl = `${BASE_URL}jobs/${job.id}`;

  const handleWhatsAppShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: `${job.companyName} Hiring ${job.title}`,
          text: message,
        })
        .catch(() => {
          const fallbackUrl = `https://wa.me/?text=${encodeURIComponent(
            `${message}\n\nApply here: ${jobUrl}`
          )}`;
          window.open(fallbackUrl, "_blank");
        });
    } else {
      const fallbackUrl = `https://wa.me/?text=${encodeURIComponent(
        `${message}\n\nApply here: ${jobUrl}`
      )}`;
      window.open(fallbackUrl, "_blank");
    }
  };

  const handleLinkedInShare = () => {
    navigator.clipboard
      .writeText(message)
      .then(() => {
        successToast(
          "Job details copied to clipboard! pinkirecting to LinkedIn..."
        );
        setTimeout(() => {
          const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
            message
          )}`;
          window.open(shareUrl, "_blank", "noopener,noreferrer");
        }, 4000);
      })
      .catch(() => {
        errorToast("Failed to copy job details. Please try again.");
      });
  };

  const handleTextCopy = () => {
    navigator.clipboard
      .writeText(message)
      .then(() => {
        successToast("Job details copied to clipboard! ");
      })
      .catch(() => {
        errorToast("Failed to copy job details. Please try again.");
      });
  };

  return (
    <div className="flex gap-2">
      {/* Desktop: full buttons */}
      <div className="hidden sm:flex gap-2">
        <button
          onClick={handleWhatsAppShare}
          className="inline-flex items-center justify-center px-3 py-2 bg-green-500 text-white text-sm rounded-xl font-medium hover:bg-green-600 transition-colors shadow-md"
          aria-label="Share on WhatsApp"
        >
          <FaWhatsapp className="mr-2" /> WhatsApp
        </button>

        <button
          onClick={handleLinkedInShare}
          className="inline-flex items-center justify-center px-3 py-2 bg-blue-700 text-white text-sm rounded-xl font-medium hover:bg-blue-800 transition-colors shadow-md"
          aria-label="Share on LinkedIn"
        >
          <FaLinkedin className="mr-2" /> LinkedIn
        </button>
        <button
          onClick={handleTextCopy}
          className="inline-flex items-center justify-center px-3 py-2 bg-pink-600 text-white text-sm rounded-xl font-medium hover:bg-pink-700 transition-colors shadow-md"
          aria-label="Copy to clipboard"
        >
          <FaCopy className="mr-2" /> Copy
        </button>
      </div>

      <div className="flex sm:hidden">
        <button
          onClick={handleWhatsAppShare}
          className="p-2 m-2 bg-green-500 text-white rounded-full"
          aria-label="Share on WhatsApp"
        >
          <FaWhatsapp />
        </button>
        <button
          onClick={handleLinkedInShare}
          className="p-2 m-2 bg-blue-500 text-white rounded-full"
          aria-label="Share on WhatsApp"
        >
          <FaLinkedin />
        </button>

        <button
          onClick={handleTextCopy}
          className="p-2 m-2 bg-pink-500 text-white rounded-full"
          aria-label="Share on WhatsApp"
        >
          <FaCopy />
        </button>
      </div>
    </div>
  );
}
